import(/* webpackMode: "eager" */ "/app/src/app/obchodni-podminky/page.tsx");
